export default {
    resultadoBuscaTodasCobrancas: {
        filtros: {
            tipo: {
                default: null,
                data: ['Começa com', 'Contém', 'Termina com'],
                value: ''
            },
            atributo: {
                default: null,
                data: ['Codigo', 'Paciente'],
                value: ''
            },
            conteudo: {
                default: null,
                label: 'Pesquisa',
                value: ''
            },
            dataVencimento: {
                default: null,
                label: 'Data Vencimento',
                value: ''
            },
            pacienteId: {
                default: null,
                value: ''
            },
            statusCobranca: {
                default: null,
                type: 'ENUM',
                label: 'Status da Cobrança',
                data: [
                    {nome: 'Todos os status', valor: 'TODOS'},
                    {nome: 'Pagamento pendente', valor: 'PENDENTE'},
                    {nome: 'Parcialmente paga', valor: 'PARCIALMENTE_PAGO'},
                    {nome: 'Pago', valor: 'PAGO'},
                    {nome: 'Cancelada', valor: 'CANCELADA'},
                ],
                enum: {
                    TODOS: 'Todos os status',
                    PENDENTE: 'Pagamento pendente',
                    PARCIALMENTE_PAGO: 'Parcialmente paga',
                    PAGO: 'Pago',
                    CANCELADA: 'Cancelada'
                },
                value: ''
            },
            tipoPeriodo: {
                default: null,
                type: 'ENUM',
                label: 'Tipo Período',
                data: [
                    {nome: 'Data criação', valor: 'DATA_CRIACAO'},
                    {nome: 'Data pagamento', valor: 'DATA_PAGAMENTO'},
                    {nome: 'Data estorno', valor: 'DATA_ESTORNO'},
                ],
                enum: {
                    DATA_CRIACAO: 'Data criação',
                    DATA_PAGAMENTO: 'Data pagamento',
                    DATA_ESTORNO: 'Data estorno'
                },
                value: ''
            },
            dataInicio: {
                default: null,
                type: 'DATA',
                label: 'Data início',
                value: ''
            },
            dataFim: {
                default: null,
                type: 'DATA',
                label: 'Data final',
                value: ''
            },
        },
        paginacao: {
            page: 1,
            size: 10,
            sort: 'codigo',
            direction: 'ASC',
        }
    },
    resultadoBuscaTodasCobrancasInterno: {
        filtros: {
            tipo: {
                default: null,
                data: ['Começa com', 'Contém', 'Termina com'],
                value: ''
            },
            atributo: {
                default: null,
                data: ['Codigo', 'Paciente'],
                value: ''
            },
            conteudo: {
                default: null,
                label: 'Pesquisa',
                value: ''
            },
            dataVencimento: {
                default: null,
                label: 'Data Vencimento',
                value: ''
            },
            pacienteId: {
                default: null,
                value: ''
            },
            statusCobranca: {
                default: null,
                type: 'ENUM',
                label: 'Status da Cobrança',
                data: [
                    {nome: 'Todos os status', valor: 'TODOS'},
                    {nome: 'Pagamento pendente', valor: 'PENDENTE'},
                    {nome: 'Parcialmente paga', valor: 'PARCIALMENTE_PAGO'},
                    {nome: 'Pago', valor: 'PAGO'},
                    {nome: 'Cancelada', valor: 'CANCELADA'},
                ],
                enum: {
                    TODOS: 'Todos os status',
                    PENDENTE: 'Pagamento pendente',
                    PARCIALMENTE_PAGO: 'Parcialmente paga',
                    PAGO: 'Pago',
                    CANCELADA: 'Cancelada'
                },
                value: 'TODOS'
            },
            tipoPeriodo: {
                default: null,
                type: 'ENUM',
                label: 'Tipo Período',
                data: [
                    {nome: 'Data criação', valor: 'DATA_CRIACAO'},
                    {nome: 'Data pagamento', valor: 'DATA_PAGAMENTO'},
                    {nome: 'Data estorno', valor: 'DATA_ESTORNO'},
                ],
                enum: {
                    DATA_CRIACAO: 'Data criação',
                    DATA_PAGAMENTO: 'Data pagamento',
                    DATA_ESTORNO: 'Data estorno'
                },
                value: ''
            },
            dataInicio: {
                default: null,
                type: 'DATA',
                label: 'Data início',
                value: ''
            },
            dataFim: {
                default: null,
                type: 'DATA',
                label: 'Data final',
                value: ''
            },
        },
        paginacao: {
            page: 1,
            size: 10,
            sort: 'codigo',
            direction: 'ASC',
        }
    },
    resultadoBuscaTodasCobrancasAtendimento: {
        filtros: {
            atendimentoId: {
                default: null,
                value: ''
            },
            calcularTotais: {
                default: null,
                value: ''
            },
        },
        paginacao: {
            page: 1,
            size: 10,
            sort: 'codigo',
            direction: 'ASC',
        }
    },
    rota: {
        origem: 'CobrancaListagem'
    }
}